module.exports = __webpack_public_path__ + "img/download-icon-white.c4658d47.svg";